export enum FrageGeschlecht {
  KEINE_PRAEFERENZ = 'keine_praeferenz',

  MANN = 'mann',

  FRAU = 'frau',
}
